export default "__VITE_ASSET__BzaEC7La__"